import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';

import { AppVersionService } from '@common/services/app-version.service';

@Component({
  selector: 'app-version-banner',
  templateUrl: './app-version-banner.component.html',
  styleUrls: ['./app-version-banner.component.less'],
  standalone: true,
  imports: [AsyncPipe, NgIf]
})
export class AppVersionBannerComponent {
  private readonly appVersionService = inject(AppVersionService);

  readonly isUpdateAvailable$ = this.appVersionService.isUpdateAvailable$;

  reload(): void {
    this.appVersionService.reload();
  }
}
